import script from "./AccountFlows.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountFlows.vue?vue&type=script&setup=true&lang=js"

import "./AccountFlows.vue?vue&type=style&index=0&id=cf0f292a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cf0f292a"]])

export default __exports__